export const MapAreaColors = {
  highlightCombinedAreas: {
    fillColor: '#555555',
  },
  highlight: {
    borderColor: '#22FF00',
    fillColor: '#1fe600',
  },
  active: {
    fillColor: '#7474f6',
    borderColor: '#FFFF00',
    borderColorAlternative: '#E6007E',
  },
  isolated: {
    borderColor: '#000',
  },
} as const;
